module.exports = __webpack_public_path__ + "fonts/LatoLatin-Semibold.3716387.eot";